import {useIsFeatureActive} from '@aboutyou/feature-flags';
import {GetWishlistPageResponse} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/wishlist/v1/page/service.types';
import React from 'react';
import styled, {css} from 'styled-components';
import {DiscountCardInformationSection} from '../../../features/HighTierCoupon/DiscountCardInformationSection';
export const WishlistDiscountSectionView = (props: GetWishlistPageResponse) => {
  const {discountCardInformationSection} = props;

  const {isActive} = useIsFeatureActive('high_tier_coupons');

  if (!discountCardInformationSection || !isActive) {
    return null;
  }

  return (
    <DiscountCardInformationSectionWrapper
      $withPadding={
        discountCardInformationSection.type?.$case === 'highTierCouponCard'
      }
    >
      <DiscountCardInformationSection
        discountCardInformationSection={discountCardInformationSection}
      />
    </DiscountCardInformationSectionWrapper>
  );
};

const DiscountCardInformationSectionWrapper = styled.div<{
  $withPadding: boolean;
}>`
  ${({$withPadding}) =>
    $withPadding &&
    css`
      padding-inline: 1rem;
      padding-block-start: 0.5rem;
    `}
`;
